import React from 'react';
import Icon from '../BaseComponentWrappers/MotifIcon';
import {alertIcError24px} from '@ey/motif-react-wrapper/assets/icons/index';
import {labels} from '../../../util/utils';
import {useIsTrackChangesView} from '../../../util/Ares/customHooks';
import styled from 'styled-components';
import {specialBodiesWithNoTrackChanges} from '../../../util/uiconstants';

function TrackChangesNotAvailableMessageContainer(props) {
	const {bodyTypeId} = props;

	const isTrackChangesView = useIsTrackChangesView();

	return isTrackChangesView && specialBodiesWithNoTrackChanges.includes(bodyTypeId) ? (
		<StyledMessageContainer className="StyledMessageContainer">
			<span className="icon-container">
				<Icon src={alertIcError24px} />
			</span>
			<span className="text-container">{labels.trackChangesNotAvailableForSpecialBodyDisplayMessage}</span>
		</StyledMessageContainer>
	) : (
		<></>
	);
}

export default TrackChangesNotAvailableMessageContainer;

const StyledMessageContainer = styled.section`
	display: flex;
	background-color: var(--neutrals-00white);
	border: var(--px-1) solid var(--neutrals-200);
	padding: var(--px-10);
	border-radius: var(--px-12) var(--px-12) var(--px-12) var(--px-12);
	width: 100%;
	margin: 0 0 var(--px-8) 0;
	.icon-container {
		display: inline-flex;
		justify-content: center;
		width: var(--px-30);
		height: var(--px-24);
		.motif-icon {
			display: flex;
			align-items: center;
		}
	}
	.text-container {
		display: inline-flex;
		align-items: center;
		font-weight: 300;
		line-height: 120%;
		font-size: var(--px-14);
		color: var(--neutrals-900);
	}
`;
